var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProcessModal',{attrs:{"title":"Var är jag i processen?","active-index":_vm.processIndex,"timeline":_vm.dynamicTimeline,"main-index":_vm.applicationIndex,"participants":_vm.applicantsStatuses,"is-loading":_vm.fetchingStatuses},on:{"click":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }